// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the EEOI Icon.
 * @param {IconProps} props - The IconProps for the EEOIIcon component.
 * @returns {ReactElement} The EEOIIcon component.
 */
export const EeoiIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon width='38' height='31' viewBox='0 0 38 31' color={color} fill='transparent' {...rest} id='eeoi'>
      <path
        d='M1.15558 29.0763H35.9945'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.4136 15.3351C35.481 17.5463 36.075 20.0241 36.075 22.64'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.07501 22.64C1.07501 13.1633 8.90873 5.48328 18.575 5.48328C20.035 5.48328 21.4548 5.66096 22.8141 5.98672'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.6285 21.1593L27.4861 16.3124C28.3017 15.9077 29.0166 17.0429 28.2917 17.5759L19.5114 24.1208C17.407 25.5719 15.3731 22.3834 17.6285 21.1593Z'
        fill='currentColor'
      />
      <path
        d='M23.6196 13.8346C23.6196 13.8346 24.546 11.2285 26.8115 10.962C29.0771 10.6955 30.7989 7.57605 30.7989 7.57605'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.1501 8.76073C25.3817 7.52679 25.6737 5.48338 28.7649 4.24944C31.2822 3.25242 32.6012 2.32449 33.2557 1.27811C33.447 0.962217 33.9304 1.03132 34.031 1.38669C34.9171 4.65417 37.4344 14.8515 28.775 13.1733'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.3233 8.76074V12.6403'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.38513 12.9956L11.1843 15.7399'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.41797 22.8868H8.3751'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M32.722 22.3932H28.7649'
        stroke='currentColor'
        strokeWidth='2.15'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Icon>
  );
};
